"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.httpClient = exports.jiveHeadersToHeadersSpec = exports.isJiveHttpHeaders = exports.responseHandler = exports.HttpResponseError = exports.JiveHttpHandler = void 0;
var rxjs_1 = require("rxjs");
/**
 *
 * Jive's custom HTTP client. The purpose of this class is to provide a common HTTP interface that will work across
 * the different frameworks that Jive uses (e.g. AngularJS and Angular). This class also provides custom options and
 * behavior that controls whether or not to include an OAuth token in HTTP requests. The default is to include the OAuth
 * token in all requests but may be disabled by setting `includeAuthorization` to `false` in the `options` provided to
 * each request method.
 *
 * @param DEFAULT_ERROR_TYPE the error type to use by default for all requests made with this client
 */
var JiveHttpHandler = /** @class */ (function () {
    function JiveHttpHandler() {
    }
    return JiveHttpHandler;
}());
exports.JiveHttpHandler = JiveHttpHandler;
var HttpResponseError = /** @class */ (function (_super) {
    __extends(HttpResponseError, _super);
    function HttpResponseError(message, responseData, status, statusText) {
        var _this = _super.call(this, message) || this;
        _this.responseData = responseData;
        _this.status = status;
        _this.statusText = statusText;
        return _this;
    }
    return HttpResponseError;
}(Error));
exports.HttpResponseError = HttpResponseError;
function responseHandler(httpResponse) {
    if (httpResponse.status >= 400 && httpResponse.status <= 500) {
        throw new HttpResponseError(httpResponse.status + ":" + httpResponse.statusText, httpResponse.data, httpResponse.status, httpResponse.statusText);
    }
    else {
        return httpResponse.data;
    }
}
exports.responseHandler = responseHandler;
/**
 * @description wrapper function for creating fetch api calls. This client is not intended to be used
 *              in framework based apps. This is a simple implementation of fetch wrapped to work with our
 *              http handler interface. This can and should be used to test or in apps where an http client is
 *              not available.
 *
 * @param {string} method the type of call to make
 * @param {string} url the http URL to make a request to
 * @param {(any | null)} [body] the body of the http request
 * @param requestHeaders the headers to be sent with the http request, defaults to adding a `Content-Type` header set to
 *   `application/json;charset=UTF-8`
 * @returns {Promise<HttpResponseData>}
 */
function fetchBase(method, url, body, requestHeaders) {
    if (!requestHeaders) {
        requestHeaders = new Headers();
    }
    // Don't add Content-Type if there is no body, this helps avoid triggering a OPTIONS request for a GET.
    if (!requestHeaders.has('Content-Type') && body) {
        requestHeaders.set('Content-Type', 'application/json;charset=UTF-8');
    }
    var opts = {
        method: method,
        body: JSON.stringify(body),
        headers: requestHeaders
    };
    return fetch(url, opts)
        .then(function (response) {
        var headers = response.headers;
        var isJson = !!headers.get('Content-Type').match('application/json');
        var createResponseData = function (res) { return function (data) {
            var status = res.status, statusText = res.statusText;
            return {
                status: status,
                statusText: statusText,
                data: data,
                headers: headers
            };
        }; };
        return (isJson ? response.json() : response.text()).then(createResponseData(response));
    });
}
function isJiveHttpHeaders(headers) {
    return !!headers &&
        !!headers.get &&
        !!headers.set &&
        !!headers.forEach;
}
exports.isJiveHttpHeaders = isJiveHttpHeaders;
function jiveHeadersToHeadersSpec(options, token) {
    var headers = options.headers;
    var reqHeaders = new Headers();
    if (isJiveHttpHeaders(headers)) {
        headers.forEach(reqHeaders.set.bind(reqHeaders));
    }
    if (!options || typeof options.includeAuthorization === 'undefined' || options.includeAuthorization) {
        reqHeaders.set('Authorization', "Bearer " + token);
    }
    return reqHeaders;
}
exports.jiveHeadersToHeadersSpec = jiveHeadersToHeadersSpec;
function httpClient(token) {
    return {
        get: function (url, options) {
            return rxjs_1.from(fetchBase('GET', url, undefined, jiveHeadersToHeadersSpec(options, token)));
        },
        post: function (url, body, options) {
            return rxjs_1.from(fetchBase('POST', url, body, jiveHeadersToHeadersSpec(options, token)));
        },
        put: function (url, body, options) {
            return rxjs_1.from(fetchBase('PUT', url, body, jiveHeadersToHeadersSpec(options, token)));
        },
        patch: function (url, body, options) {
            return rxjs_1.from(fetchBase('PATCH', url, body, jiveHeadersToHeadersSpec(options, token)));
        },
        delete: function (url, options) {
            return rxjs_1.from(fetchBase('DELETE', url, undefined, jiveHeadersToHeadersSpec(options, token)));
        }
    };
}
exports.httpClient = httpClient;
//# sourceMappingURL=http.js.map